var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonPlain',_vm._g(_vm._b({staticClass:"app-shortcut"},'ButtonPlain',_vm.$attrs,false),_vm.$listeners),[_c('img',{attrs:{"src":_vm.icon,"alt":_vm.name}}),_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }